import React from 'react'

export const ImageComponent = ({className="",path=""}) => {

    const image =  require(`./${path}`);

  return (
    <img src={image} className={className} alt='avtar'/>
  )
}
